import * as Sentry from "@sentry/vue";

/**
 * Capture exception with user context
 */
export function captureExceptionWithTrace(
  error: unknown,
  context?: {
    extra?: Record<string, unknown>;
    tags?: Record<string, string>;
    level?: Sentry.SeverityLevel;
  }
) {
  // Extract username from extra context if provided
  const username = context?.extra?.username;

  // Set user context in Sentry if username is available
  if (username && typeof username === "string") {
    Sentry.setUser({
      username: username,
    });
  }

  Sentry.captureException(error, {
    ...context,
    tags: {
      ...context?.tags,
      ...(username ? { username: String(username) } : {}),
    },
  });
}
